import React, { useState } from "react";
import { tootltip } from "../../assets/img";

const PriceOwnerAdmin = ({ PriceDetails }) => {
  const [toolTip, setToolTip] = useState(false);

  const showToolTip = (d) => {
    setToolTip(d);
    setTimeout(() => {
      setToolTip(false);
    }, 2500);
  };

  console.log("priceDetails", PriceDetails);
  return (
    <div className="d-flex flex-column gap-5 col-md-5 mt-0">
      <div className="roles-bg rounded-4 mt-0">
        <h2 className=" d-flex f4 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mt-2">
          Owner Amount{" "}
          {PriceDetails?.is_cancellation_booking && (
            <p className=" f4 fs-sm-14 ms-2 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 red">
              Cancelled
            </p>
          )}
        </h2>
        <div className="d-flex as-js mt-3">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
            {" "}
            Total Price
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {PriceDetails?.total_price}
          </p>
        </div>
        <div className="d-flex as-js mt-3">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
            Owner Amount (A)
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {PriceDetails?.owner_amount} ( include Tax)
          </p>
        </div>
        <div className="d-flex as-js mt-3">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
            {" "}
            TDS (2%) (B)
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {PriceDetails?.tds}
          </p>
        </div>
        <div className="d-flex as-js mt-3">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
            {" "}
            TAX (5%) (C)
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {PriceDetails?.tax}
          </p>
        </div>

        {/* {PriceDetails?.user_paid_amount !== 0 && (
          <div className="d-flex as-js mt-3">
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
              {" "}
              User Paid Amount
            </p>
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
              {" "}
              : {PriceDetails?.user_paid_amount}
            </p>
          </div>
        )} */}
        {/* {PriceDetails?.user_balance_to_pay !== 0 && (
          <div className="d-flex as-js mt-3">
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
              {" "}
              User Balance To Pay (D)
            </p>
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
              {" "}
              : {PriceDetails?.user_balance_to_pay}
            </p>
          </div>
        )} */}

        {/* {PriceDetails?.user_balance_to_pay !== 0 && (
          <div className="d-flex as-js mt-3 position-relative">
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6 ">
              {" "}
              Owner Amount Payable (E)
              <img
                style={{ marginLeft: "1px" }}
                src={tootltip}
                onClick={() => {
                  showToolTip("No_Of_Persons");
                }}
                className="tooltip-icon"
                alt=""
              />
              {toolTip === "No_Of_Persons" && (
                <div className="tooltip-popup absolute">
                  <p className="tooltip-text">
                    {"(UPA + Coupon + Wallet amount) - (Vow Money + TDS)"}
                  </p>
                </div>
              )}
            </p>
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
              {" "}
              : {PriceDetails?.owner_amount_payable_formula}
            </p>
          </div>
        )} */}

        <div className="d-flex as-js mt-3">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
            {" "}
            Final Amount
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {PriceDetails?.final_amount}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PriceOwnerAdmin;
